import { supabase } from './supabase';
import { Department } from '../types';

export const departmentService = {
  // Get all departments
  async getAll(): Promise<Department[]> {
    const { data, error } = await supabase
      .from('departments')
      .select('*')
      .order('name', { ascending: true });

    if (error) {
      console.error('Error fetching departments:', error);
      if (error.code === '42P01') {
        throw new Error('Database tables not found. Please run the setup script first.');
      }
      return [];
    }

    return data as Department[];
  },

  // Get department by ID
  async getById(id: string): Promise<Department | null> {
    const { data, error } = await supabase
      .from('departments')
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      console.error(`Error fetching department with ID ${id}:`, error);
      return null;
    }

    return data as Department;
  },

  // Create a new department
  async create(department: Omit<Department, 'id' | 'created_at' | 'updated_at'>): Promise<Department | null> {
    const { data, error } = await supabase
      .from('departments')
      .insert([{ ...department }])
      .select()
      .single();

    if (error) {
      console.error('Error creating department:', error);
      return null;
    }

    return data as Department;
  },

  // Update a department
  async update(id: string, department: Partial<Department>): Promise<Department | null> {
    const { data, error } = await supabase
      .from('departments')
      .update({ ...department, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();

    if (error) {
      console.error(`Error updating department with ID ${id}:`, error);
      return null;
    }

    return data as Department;
  },

  // Delete a department
  async delete(id: string): Promise<boolean> {
    const { error } = await supabase
      .from('departments')
      .delete()
      .eq('id', id);

    if (error) {
      console.error(`Error deleting department with ID ${id}:`, error);
      return false;
    }

    return true;
  },
};